import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import PageWrapper from '../../components/PageWrapper';
import LogoBanner from '../../components/LogoBanner';
import PremierSponsorBanner from '../../components/PremierSponsorBanner';
import SponsorBanner from '../../components/SponsorBanner';
import InsideHeader from '../../components/InsideHeader';
import ConferenceTable from './ConferenceTable';

const styles = css`
  padding: 45px 0;
  @media (min-width: 992px) {
    padding: 120px 0 300px 0;
  }
`;

function Index({ page, widget }) {
  return (
    <PageWrapper>
      <PageHelmet custom title="Conference Info" />
      <InsideHeader />
      <div className={styles}>
        <ConferenceTable page={page} widget={widget} />
      </div>
      <LogoBanner />
      <PremierSponsorBanner />
      <SponsorBanner />
    </PageWrapper>
  );
}

Index.propTypes = {
  page: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData({
  page: 'agenda',
  widget: 'speakers',
})(Index);



// WEBPACK FOOTER //
// ./src/pages/Conference/index.js